import { gql } from '@apollo/client'

export const boothFragments = gql`
    fragment BoothData on Booth {
        id
        table_number
        room
        x
        y
        grid_width
        grid_height
        booth_type
        sponsored
        is_paid
        paid_in_cash
        is_overdue
        payment_deadline
        price
        is_taken
        user_id
        user {
            id
            email
            company_name
        }
        product_variation_id
        convention_id
    }
`

export const GET_BOOTH = gql`
    query getBooth($table_number: String!, $room: String!, $convention_id: ID!) {
        booth(table_number: $table_number, room: $room, convention_id: $convention_id) {
            ...BoothData
            shared_booths {
                id
                table_number
            }
            group {
                id
                table_number
            }
        }
    }
    ${boothFragments}
`

export const GET_BOOTH_BY_ID = gql`
    query getBoothById($id: ID!) {
        booth(id: $id) {
            ...BoothData
            shared_booths {
                id
                table_number
            }
            group {
                id
                table_number
            }
        }
    }
    ${boothFragments}
`

export const UPDATE_BOOTH = gql`
    mutation updateBooth($input: UpdateBoothInput!) {
        updateBooth(input: $input) {
            booth {
                ...BoothData
            }
        }
    }
    ${boothFragments}
`

export const UPDATE_BOOTH_POSITION = gql`
    mutation updateBoothPosition($input: UpdateBoothPositionInput!) {
        updateBoothPosition(input: $input) {
            booth {
                ...BoothData
            }
        }
    }
    ${boothFragments}
`

export const ASSIGN_VENDOR_TO_BOOTH = gql`
    mutation assignVendorToBooth($input: AssignVendorToBoothInput!) {
        assignVendorToBooth(input: $input) {
            booth {
                ...BoothData
            }
        }
    }
    ${boothFragments}
`

export const CREATE_BOOTH = gql`
    mutation createBooth($input: CreateBoothInput!) {
        createBooth(input: $input) {
            booth {
                ...BoothData
            }
        }
    }
    ${boothFragments}
`

export const DELETE_BOOTH = gql`
    mutation deleteBooth($input: DeleteBoothInput!) {
        deleteBooth(input: $input) {
            booth {
                ...BoothData
            }
        }
    }
    ${boothFragments}
`

export const GET_BOOTHS = gql`
    query getBooths($convention_id: ID!, $room: String!) {
        booths(convention_id: $convention_id, room: $room) {
            ...BoothData
            shared_booths {
                id
            }
        }
    }
    ${boothFragments}
`

export const GET_VENDORS = gql`
    query getVendors($convention_id: ID!) {
        vendors(convention_id: $convention_id) {
            id
            email
            company_name
            booths {
                id
                table_number
            }
        }
    }
`

export const GET_BOOTH_PRODUCTS = gql`
    query getProducts($convention_id: ID!, $category: String!) {
        products(convention_id: $convention_id, category: $category) {
            id
            name
            product_variations {
                id
                name
                current_tier {
                    id
                    price
                }
                product_tiers {
                    id
                    start_time
                    end_time
                    price
                }
            }
        }
    }
`
